import React, { type ReactNode } from 'react';
import type { RouterActionsType } from '../router-store/types.tsx';
import { useRouterActions } from '../use-router-actions/useRouterActions.tsx';

type RouterActionsProps = {
	children: (actions: RouterActionsType) => ReactNode;
};

export const RouterActions: {
	({ children }: RouterActionsProps): React.JSX.Element;
	displayName: string;
} = ({ children }: RouterActionsProps): React.JSX.Element => {
	const actions = useRouterActions();

	return <>{children(actions)}</>;
};

RouterActions.displayName = 'RouterActions';
